module.exports = __webpack_public_path__ + "img/ceshi1.71d261dc.png";